import { GraphQLResolveInfo } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type CreateSpellbookResponse = {
  __typename?: 'CreateSpellbookResponse';
  id: Scalars['ID']['output'];
  spellbook: Spellbook;
};

export enum MagicSchool {
  Abjuration = 'Abjuration',
  Conjuration = 'Conjuration',
  Divination = 'Divination',
  Enchantment = 'Enchantment',
  Evocation = 'Evocation',
  Illusion = 'Illusion',
  Necromancy = 'Necromancy',
  Transmutation = 'Transmutation'
}

export type Mutation = {
  __typename?: 'Mutation';
  createSpellbook?: Maybe<CreateSpellbookResponse>;
  updateSpellbook?: Maybe<UpdateSpellbookResponse>;
};


export type MutationCreateSpellbookArgs = {
  spellbook: SpellbookInput;
};


export type MutationUpdateSpellbookArgs = {
  id: Scalars['ID']['input'];
  spellbook: SpellbookInput;
};

export type Query = {
  __typename?: 'Query';
  spellbook?: Maybe<Spellbook>;
};


export type QuerySpellbookArgs = {
  id: Scalars['ID']['input'];
};

export type Spell = {
  __typename?: 'Spell';
  alwaysPrepared: Scalars['Boolean']['output'];
  areaOfEffect?: Maybe<SpellAreaOfEffect>;
  castTime: SpellCastTime;
  components: SpellComponents;
  concentration: Scalars['Boolean']['output'];
  description: Array<Scalars['String']['output']>;
  duration: SpellDuration;
  higherLevel?: Maybe<Scalars['String']['output']>;
  level: SpellLevel;
  name: Scalars['String']['output'];
  range: SpellRange;
  ritual: Scalars['Boolean']['output'];
  school: MagicSchool;
};

export type SpellAreaOfEffect = {
  __typename?: 'SpellAreaOfEffect';
  dimensions?: Maybe<Scalars['Int']['output']>;
  type: SpellAreaOfEffectType;
};

export type SpellAreaOfEffectInput = {
  dimensions: Scalars['Int']['input'];
  type: SpellAreaOfEffectType;
};

export enum SpellAreaOfEffectType {
  Cone = 'CONE',
  Cube = 'CUBE',
  Cylinder = 'CYLINDER',
  Line = 'LINE',
  Sphere = 'SPHERE',
  Square = 'SQUARE'
}

export type SpellCastTime = {
  __typename?: 'SpellCastTime';
  duration?: Maybe<Scalars['Int']['output']>;
  type: SpellCastTimeType;
};

export type SpellCastTimeInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  type: SpellCastTimeType;
};

export enum SpellCastTimeType {
  Action = 'ACTION',
  BonusAction = 'BONUS_ACTION',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Reaction = 'REACTION'
}

export type SpellComponents = {
  __typename?: 'SpellComponents';
  material?: Maybe<Scalars['String']['output']>;
  somatic: Scalars['Boolean']['output'];
  verbal: Scalars['Boolean']['output'];
};

export type SpellComponentsInput = {
  material?: InputMaybe<Scalars['String']['input']>;
  somatic: Scalars['Boolean']['input'];
  verbal: Scalars['Boolean']['input'];
};

export type SpellDuration = {
  __typename?: 'SpellDuration';
  duration?: Maybe<Scalars['Int']['output']>;
  type: SpellDurationType;
};

export type SpellDurationInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  type: SpellDurationType;
};

export enum SpellDurationType {
  Days = 'DAYS',
  Hours = 'HOURS',
  Instantaneous = 'INSTANTANEOUS',
  Minutes = 'MINUTES',
  Round = 'ROUND',
  Special = 'SPECIAL',
  UntilDispelled = 'UNTIL_DISPELLED',
  UntilDispelledOrTriggered = 'UNTIL_DISPELLED_OR_TRIGGERED'
}

export type SpellInput = {
  alwaysPrepared: Scalars['Boolean']['input'];
  areaOfEffect?: InputMaybe<SpellAreaOfEffectInput>;
  castTime: SpellCastTimeInput;
  components: SpellComponentsInput;
  concentration: Scalars['Boolean']['input'];
  description: Array<Scalars['String']['input']>;
  duration: SpellDurationInput;
  higherLevel?: InputMaybe<Scalars['String']['input']>;
  level: SpellLevel;
  name: Scalars['String']['input'];
  range: SpellRangeInput;
  ritual: Scalars['Boolean']['input'];
  school: MagicSchool;
};

export enum SpellLevel {
  Cantrip = 'Cantrip',
  Lvl_1st = 'LVL_1st',
  Lvl_2nd = 'LVL_2nd',
  Lvl_3rd = 'LVL_3rd',
  Lvl_4th = 'LVL_4th',
  Lvl_5th = 'LVL_5th',
  Lvl_6th = 'LVL_6th',
  Lvl_7th = 'LVL_7th',
  Lvl_8th = 'LVL_8th',
  Lvl_9th = 'LVL_9th'
}

export type SpellRange = {
  __typename?: 'SpellRange';
  distance?: Maybe<Scalars['Int']['output']>;
  range: SpellRangeType;
};

export type SpellRangeInput = {
  distance?: InputMaybe<Scalars['Int']['input']>;
  range: SpellRangeType;
};

export enum SpellRangeType {
  Feet = 'FEET',
  Self = 'SELF',
  Touch = 'TOUCH',
  Unlimited = 'UNLIMITED'
}

export type Spellbook = {
  __typename?: 'Spellbook';
  maxPrepared: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['ID']['output'];
  spells: Array<Spell>;
};

export type SpellbookInput = {
  maxPrepared: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  spells: Array<SpellInput>;
};

export type UpdateSpellbookResponse = {
  __typename?: 'UpdateSpellbookResponse';
  id: Scalars['ID']['output'];
  spellbook: Spellbook;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CreateSpellbookResponse: ResolverTypeWrapper<CreateSpellbookResponse>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  MagicSchool: MagicSchool;
  Mutation: ResolverTypeWrapper<{}>;
  Query: ResolverTypeWrapper<{}>;
  Spell: ResolverTypeWrapper<Spell>;
  SpellAreaOfEffect: ResolverTypeWrapper<SpellAreaOfEffect>;
  SpellAreaOfEffectInput: SpellAreaOfEffectInput;
  SpellAreaOfEffectType: SpellAreaOfEffectType;
  SpellCastTime: ResolverTypeWrapper<SpellCastTime>;
  SpellCastTimeInput: SpellCastTimeInput;
  SpellCastTimeType: SpellCastTimeType;
  SpellComponents: ResolverTypeWrapper<SpellComponents>;
  SpellComponentsInput: SpellComponentsInput;
  SpellDuration: ResolverTypeWrapper<SpellDuration>;
  SpellDurationInput: SpellDurationInput;
  SpellDurationType: SpellDurationType;
  SpellInput: SpellInput;
  SpellLevel: SpellLevel;
  SpellRange: ResolverTypeWrapper<SpellRange>;
  SpellRangeInput: SpellRangeInput;
  SpellRangeType: SpellRangeType;
  Spellbook: ResolverTypeWrapper<Spellbook>;
  SpellbookInput: SpellbookInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  UpdateSpellbookResponse: ResolverTypeWrapper<UpdateSpellbookResponse>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean']['output'];
  CreateSpellbookResponse: CreateSpellbookResponse;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  Mutation: {};
  Query: {};
  Spell: Spell;
  SpellAreaOfEffect: SpellAreaOfEffect;
  SpellAreaOfEffectInput: SpellAreaOfEffectInput;
  SpellCastTime: SpellCastTime;
  SpellCastTimeInput: SpellCastTimeInput;
  SpellComponents: SpellComponents;
  SpellComponentsInput: SpellComponentsInput;
  SpellDuration: SpellDuration;
  SpellDurationInput: SpellDurationInput;
  SpellInput: SpellInput;
  SpellRange: SpellRange;
  SpellRangeInput: SpellRangeInput;
  Spellbook: Spellbook;
  SpellbookInput: SpellbookInput;
  String: Scalars['String']['output'];
  UpdateSpellbookResponse: UpdateSpellbookResponse;
};

export type CreateSpellbookResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSpellbookResponse'] = ResolversParentTypes['CreateSpellbookResponse']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  spellbook?: Resolver<ResolversTypes['Spellbook'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createSpellbook?: Resolver<Maybe<ResolversTypes['CreateSpellbookResponse']>, ParentType, ContextType, RequireFields<MutationCreateSpellbookArgs, 'spellbook'>>;
  updateSpellbook?: Resolver<Maybe<ResolversTypes['UpdateSpellbookResponse']>, ParentType, ContextType, RequireFields<MutationUpdateSpellbookArgs, 'id' | 'spellbook'>>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  spellbook?: Resolver<Maybe<ResolversTypes['Spellbook']>, ParentType, ContextType, RequireFields<QuerySpellbookArgs, 'id'>>;
};

export type SpellResolvers<ContextType = any, ParentType extends ResolversParentTypes['Spell'] = ResolversParentTypes['Spell']> = {
  alwaysPrepared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  areaOfEffect?: Resolver<Maybe<ResolversTypes['SpellAreaOfEffect']>, ParentType, ContextType>;
  castTime?: Resolver<ResolversTypes['SpellCastTime'], ParentType, ContextType>;
  components?: Resolver<ResolversTypes['SpellComponents'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['SpellDuration'], ParentType, ContextType>;
  higherLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<ResolversTypes['SpellLevel'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['SpellRange'], ParentType, ContextType>;
  ritual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  school?: Resolver<ResolversTypes['MagicSchool'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpellAreaOfEffectResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpellAreaOfEffect'] = ResolversParentTypes['SpellAreaOfEffect']> = {
  dimensions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SpellAreaOfEffectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpellCastTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpellCastTime'] = ResolversParentTypes['SpellCastTime']> = {
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SpellCastTimeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpellComponentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpellComponents'] = ResolversParentTypes['SpellComponents']> = {
  material?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  somatic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  verbal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpellDurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpellDuration'] = ResolversParentTypes['SpellDuration']> = {
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SpellDurationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpellRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpellRange'] = ResolversParentTypes['SpellRange']> = {
  distance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  range?: Resolver<ResolversTypes['SpellRangeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpellbookResolvers<ContextType = any, ParentType extends ResolversParentTypes['Spellbook'] = ResolversParentTypes['Spellbook']> = {
  maxPrepared?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  spells?: Resolver<Array<ResolversTypes['Spell']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateSpellbookResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSpellbookResponse'] = ResolversParentTypes['UpdateSpellbookResponse']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  spellbook?: Resolver<ResolversTypes['Spellbook'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  CreateSpellbookResponse?: CreateSpellbookResponseResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Spell?: SpellResolvers<ContextType>;
  SpellAreaOfEffect?: SpellAreaOfEffectResolvers<ContextType>;
  SpellCastTime?: SpellCastTimeResolvers<ContextType>;
  SpellComponents?: SpellComponentsResolvers<ContextType>;
  SpellDuration?: SpellDurationResolvers<ContextType>;
  SpellRange?: SpellRangeResolvers<ContextType>;
  Spellbook?: SpellbookResolvers<ContextType>;
  UpdateSpellbookResponse?: UpdateSpellbookResponseResolvers<ContextType>;
};

